<template>
  <div>
    <TwTable
      :searchData="searchData"
      :tableData="tableData"
      :tableConfig="tableConfig"
      :pageConfig="pageConfig"
      :buttonList="buttonList"
      @btnCallFunction="callFunction"
      @resetBtn="resetBtn"
      @handleCellClick="handleCellClick"
      @handleCurrentChange="handleCurrentChange"
      @handleSelectCheckbox="handleSelectCheckbox"
      @searchChange="searchChange"
      @handleSizeChange="handleSizeChange"
      @getTableEle="getTableEle"
      @handleSelsChange="handleSelsChange"
      @handleOperateEvent="handleOperateEvent"
    >
      <template v-slot:orgId>
        <el-select multiple filterable v-model="filters.orgId" placeholder="请选择" collapse-tags>
          <el-option
            v-for="item in organizations"
            :label="item.customName"
            :value="item.id"
            :key="item.id"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:warehouseId>
        <el-select multiple filterable v-model="filters.warehouseId" placeholder="请选择" collapse-tags>
          <el-option
            v-for="item in warehouses"
            :label="item.warehouseName"
            :value="item.warehouseId"
            :key="item.warehouseId"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:tdate>
        <el-date-picker
          v-model="filters.tdate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
        >
        </el-date-picker>
      </template>
      <template v-slot:putOnStatus>
        <el-select multiple  v-model="filters.putOnStatus" placeholder="请选择" collapse-tags>
          <el-option
            v-for="item in putOnStatusList"
            :label="item.text"
            :value="item.value"
            :key="item.value"
          ></el-option>
        </el-select>
      </template>
      <template v-slot:realName>
        <el-select multiple v-model="filters.realName" filterable placeholder="请选择" collapse-tags>
          <el-option
            v-for="item in userList"
            :label="item.realName"
            :value="item.realName"
            :key="item.realName"
          ></el-option>
        </el-select>
      </template>
      
      <template slot-scope="scope" slot="shangja">
        <el-link v-if="scope.row.putOnStatus == 10 || scope.row.putOnStatus == 20"
          :underline="false"
          type="primary"
          @click.native="addPutOnInfo(scope.row)"
          >上架
        </el-link>
      </template>
    </TwTable>

    <!-- 上架模块 -->
    <el-dialog
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
      width="40%"
    >
      <el-form
        :model="editForm"
        label-width="80px"
        ref="editRuleForm"
        :rules="editFormRules"
      >
        <el-row>
          <el-col>
            <el-form-item label="库位" prop="LocationCode">
              <el-input
                v-model="editForm.LocationCode"
                auto-complete="off"
                placeholder="请输入库位"
                maxlength="50"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row type="flex" class="row-bg" justify="end">
          <el-button @click.native="editFormVisible = false">取消</el-button>
          <el-button type="primary" @click="onEditSubmit" :loading="editLoading"
            >确认上架</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import {
  getPutOnStatus,
  getShelvesManagementAsync,
  exportShelvesManagementOut,
  submitPutStockBox,
} from "@/api/receive/BatchGoods.js";
import { getButtonList } from "../../promissionRouter";
import TwTable from "../../components/TwTable/TwTable";
import { TwTable_mixins } from "../../components/TwTable/mixins";
import { getCustomerList } from "@/api/ProductSku.js";
import axios from "axios";
import {
  getOperatorInfo,
} from "../../api/api";
import { thereAre } from "util/util";
export default {
  components: { TwTable },
  mixins: [TwTable_mixins],
  data() {
    return {
      tableConfig: {
        showResetButton: true,
        showSelection: true, // 显示多选框
        showRadio: true, // 显示单选框
        showIndex: false, // 显示序号
        loading: false, // 显示loading状态
        showPage: true, // 显示分页
        size: "medium", // table的尺寸  medium / small / mini
        showOperate: true, // 显示操作栏
        operate: {
          //操作栏配置
          align: "center",

          options: [
            {
              prop: "shangja",
              name: "上架",
              size: "small",
              type: "text",
              event: "addPutOnInfo", // 操作的事件名
              slot: true,
            },
          ],
        },
        column: [
          // 表格列配置
          {
            prop: "putOnNo",
            label: "签收单号",
            align: "center",
            sortable: true,
            minWidth: "130",
          },
          {
            prop: "sourceNumber",
            label: "收货单号",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            prop: "trackNumber",
            label: "跟踪号",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
          {
            prop: "warehouseName",
            label: "仓库",
            align: "center",
            sortable: true,
            minWidth: "120",
          },

          {
            prop: "customName",
            label: "客户代码",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "putOnStatusText",
            label: "状态",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
           {
            prop: "createUser",
            label: "操作人",
            align: "center",
            sortable: true,
            minWidth: "100",
          },
          {
            prop: "createTime",
            label: "收货完成时间",
            align: "center",
            minWidth: "150",
            sortable: true,
          },

          {
            prop: "overPutStockTime",
            label: "上架完成时间",
            align: "center",
            sortable: true,
            minWidth: "150",
          },
        ],
      },
      searchData: {
        //搜索列配置

        search: [
          {
            type: "select",
            key: "orgId",
            prop: "orgId",
            label: "客户",
            multiple: true,
            slot: true,
            placeholder: "请选择客户",
            option: this.organizations,
          },
          {
            type: "select",
            key: "warehouseId",
            prop: "warehouseId",
            label: "仓库",
            multiple: true,
            slot: true,
            placeholder: "请选择仓库",
            option: this.warehouses,
          },
          {
            type: "select",
            key: "putOnStatus",
            prop: "putOnStatus",
            label: "状态",
            multiple: true,
            slot: true,
            placeholder: "请选择状态",
            option: this.putOnStatusList,
          },
          {
            type: "input",
            key: "sourceNumber",
            label: "收货单号",
            placeholder: "多个收货单号用逗号分开查询",
            clearable: true,
          },
          
        ],
        ///高级搜索配置
        moreSearch: [
          {
            type: "input",
            key: "trackNumber",
            label: "跟踪号",
            placeholder: "多个跟踪号用逗号分开查询",
            clearable: true,
          },
          {
            type: "input",
            key: "putOnNo",
            label: "签收单号",
            placeholder: "多个签收单号用逗号分开查询",
            clearable: true,
          },
          {
            key: "tdate",
            prop: "tdate",
            slot: true,
            label: "上架完成时间",
          },
{
            type: "select",
            key: "realName",
            prop: "realName",
            label: "操作人",
            multiple: true,
            slot: true,
            placeholder: "",
            option: this.userList,
          },
        ],
      },
      buttonList: [],

      //-------------
      organizations: [],
      warehouses: [],
      putOnStatusList: [],
      userList:[],
      editFormVisible: false,
      editLoading: false,
      editForm: {
        LocationCode: "",
      },
      editFormRules: {
        LocationCode: [
          {
            required: true,
            message: "请输入库位",
            trigger: "blur",
          },
        ],
      },
    };
  },
  methods: {
    resetBtn() {
      this.filters = {};
    },
    callFunction(item) {
      if (item.name === "查询") {
        this.$set(this.pageConfig, "pageIndex", 1);
        this.newfilters = JSON.parse(JSON.stringify(this.filters));
        this.initTable.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },
    //上架
    addPutOnInfo(row) {
      this.currentRow = row;
      if (row.putOnStatus == 10 || row.putOnStatus == 20) {
        this.editFormVisible = true;
        console.log(this.currentRow);
      } else {
        this.$message({
          message: "只能操作待上架，部分上架数据",
          type: "error",
        });
      }
    },
    //查询列表
    initTable() {
      const {
        orgId,
        warehouseId,
        putOnStatus,
        sourceNumber,
        realName,
        trackNumber,
        putOnNo,
        tdate,
      } = this.newfilters;
      let para = {
        page: this.pageConfig.pageIndex,
        pageSize: this.pageConfig.pageSize,
        orgId: thereAre(orgId),
        warehouseId: thereAre(warehouseId),
        putOnStatus: thereAre(putOnStatus),
        realName: thereAre(realName),
        sourceNumber,
        trackNumber,
        putOnNo,
      };
      if (tdate != null && tdate != "null") {
        para.startdate = tdate[0];
        para.enddate = tdate[1];
      }
      this.tableConfig.loading = true;
      this.tableConfig.showPage = false;
      getShelvesManagementAsync(para).then((res) => {
        const { total, pageData, pageIndex, pageSize } = res.data.response;

        this.$set(this.pageConfig, "total", total);
        this.$set(this.pageConfig, "pageIndex", pageIndex);
        this.$set(this.pageConfig, "pageSize", pageSize);
        this.tableData = pageData;
        this.tableConfig.loading = false;
        this.tableConfig.showPage = true;
      });
    },
    //导出
    handleExport() {
      let row = this.selectRows.rows;

      let putOnInfoIDs = "";
      row.forEach((item) => {
        putOnInfoIDs += item.putOnInfoID + ",";
      });

      const {
        orgId,
        warehouseId,
        putOnStatus,
        sourceNumber,
        trackNumber,
        putOnNo,
        tdate,
      } = this.newfilters;
      let pata = {
        page: 1,
        pageSize: 60001,
        orgId: thereAre(orgId),
        warehouseId: thereAre(warehouseId),
        putOnStatus: thereAre(putOnStatus),
        sourceNumber,
        trackNumber,
        putOnNo,
        putOnInfoIDs: thereAre(putOnInfoIDs),
      };
      if (tdate != null && tdate != "null") {
        pata.startdate = tdate[0];
        pata.enddate = tdate[1];
      }
      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });
      axios({
        url: exportShelvesManagementOut,
        method: "post",
        data: pata,
        //responseType: "blob",
      })
        .then((res) => {
          console.log(res);
          loading.close();
          if (res.data.success) {
            var data = res.data.response;

            var arr = data.fileData.split(",");
            var mime = arr[0].match(/:(.*?);/)[1];
            console.log(mime);
            var bstr = atob(arr[1]);
            var n = bstr.length;
            var u8arr = new Uint8Array(n);
            while (n--) {
              u8arr[n] = bstr.charCodeAt(n);
            }
            console.log(u8arr);
            var blob = new Blob([u8arr], { type: mime });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            let fileName = data.fileName;
            a.download = decodeURIComponent(fileName);
            a.click();
            window.URL.revokeObjectURL(url);
          } else {
            this.$message({
              message: res.data.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          console.error(err);
        });
    },
    //上架
    onEditSubmit() {
      this.$refs.editRuleForm.validate((valid) => {
        if (valid) {
          let pata = {
            PutOnInfoID: this.currentRow.putOnInfoID,
            StorageName: this.editForm.LocationCode,
          };
          this.editLoading = true;
          submitPutStockBox(pata).then((res) => {
               this.editLoading = false;
            if (res.data.success) {
             
              this.$message({
                message: "上架成功",
                type: "success",
              });
           
              this.editFormVisible = false;
              this.initTable();
            } else {
              this.$message({
                message: res.data.msg,
                type: "error",
              });
            }
          });
        }
      });
    },
    //单选选中复选框
    handleCellClick(row, column, event) {
      this.tableEle.toggleRowSelection(row);
    },
  },

  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];

    this.buttonList = getButtonList(this.$route.path, routers);

    let user = JSON.parse(window.localStorage.user);
    this.warehouses = user.warehouseList;
    let para = {
      IsAll: true,
    };
    getCustomerList(para).then((res) => {
      this.organizations = res.data.response;
    });
    getPutOnStatus("").then((res) => {
      this.putOnStatusList = res.data.response;
    });
    getOperatorInfo().then(
        (res) => {
          this.userList = res.data.response;
        }
      );
  },
};
</script>